export const SHOW_BOTTOM_NAV_BAR = false;
